module.exports = __webpack_public_path__ + "static/media/dicero_page_area02_img_cn.ea7b9854.png";